import React from 'react'

const Social = () => {
  return (
    <div className="home__social">
        <a href="https://www.instagram.com/pankaj_maurya_352/" className="home__social-icon" target='_blank' rel="noreferrer">
            <i className="uil uil-instagram"></i>
        </a>
        <a href="https://www.linkedin.com/in/pankaj-maurya-7a9172228/" className="home__social-icon" target='_blank' rel="noreferrer">
        <i className="uil uil-linkedin"></i>
        </a>
        <a href="https://github.com/Pankaj352" className="home__social-icon" target='_blank' rel="noreferrer">
        <i className="uil uil-github-alt"></i>
        </a>
    </div>
  )
}

export default Social
